import {defineAsyncComponent} from 'vue';

const dictionaryExpenseOtherDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryExpenseOther/DictionaryExpenseOtherDetail.vue'),
);

const dictionaryPatternRegularDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPatternRegular/DictionaryPatternRegularDetail.vue'),
);

const dictionaryPatternRegularFieldList = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPatternRegular/DictionaryPatternRegularFieldList.vue'),
);
const dictionaryPatternRegularAddSubItemsPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPatternRegular/DictionaryPatternRegularAddSubItemsPopup.vue'),
);
const dictionaryAddRegularFailPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPatternRegular/DictionaryAddRegularFailPopup.vue'),
);

const revenueOtherDetail = defineAsyncComponent(() => import('@/views/dictionary/revenueOther/RevenueOtherDetail.vue'));

const expenseInvestDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/expenseInvest/ExpenseInvestDetail.vue'),
);

const expenseInvestTaskDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/expenseInvest/ExpenseInvestTaskDetail.vue'),
);

const dictionaryBusinessDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryBusiness/DictionaryBusinessDetail.vue'),
);
const dictionaryFeesDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryFees/DictionaryFeesDetail.vue'),
);
const dictionaryPresentDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentDetail.vue'),
);
const dictionaryPresentSetup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentSetup.vue'),
);
const dictionaryPresentEdit = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentEdit.vue'),
);
const dictionaryPresentWorkbook = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentWorkbook.vue'),
);
const dictionaryPresentView = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentView.vue'),
);
const dictionaryPresentCustom = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentCustom.vue'),
);
const dictionaryReportCustomTool = defineAsyncComponent(() =>
  import('@/views/dictionary/DictionaryReportCustomTool.vue'),
);
const dictionaryPresentCustomColumn = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentCustomColumn.vue'),
);
const dictionaryReportCustomPrint = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryReportCustomPrint.vue'),
);

const dictionaryPresentCustomPrintGeneral = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentCustomPrintGeneral.vue'),
);
const dictionaryPresentCustomPrintSettingArea = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentCustomPrintSettingArea.vue'),
);
const dictionaryPresentCustomPrintSettingCell = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentCustomPrintSettingCell.vue'),
);
const dictionaryPresentCustomPrintSettingCellCondition = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentCustomPrintSettingCellCondition.vue'),
);
const dictionaryPresentDatatableDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DataTable/DictionaryPresentDatatableDetail.vue'),
);
const optionExplanationFormModelPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DataTable/popup/OptionExplanationFormModelPopup.vue'),
);
const dictionaryPresentDatatableDetailValue = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DataTable/DictionaryPresentDatatableDetailValue.vue'),
);
const dictionaryPresentDatatableCalculator = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DataTable/DictionaryPresentDatatableCalculator.vue'),
);
const dictionaryPresentDatatableDetailListConditions = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DataTable/DictionaryPresentDatatableDetailListConditions.vue'),
);
const fieldQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DataTable/FieldQuickSearch.vue'),
);
const reportQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/ReportQuickSearch.vue'),
);
const dictionaryReportCustomDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryReportCustom/DictionaryReportCustomDetail.vue'),
);
const dictionaryFeesSetRatio = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryFees/DictionaryFeesSetRatio.vue'),
);
const dictionaryRevenueBudgetDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRevenueBudget/DictionaryRevenueBudgetDetail.vue'),
);
// const dictionaryPresentDatatable = defineAsyncComponent(() =>
//   import('@/views/dictionary/dictionaryPresentOther/DataTable/DictionaryPresentDatatable.vue'),
// );
const dictionaryRevenueBudgetRate = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRevenueBudget/DictionaryRevenueBudgetRate.vue'),
);
const criteriaDetail = defineAsyncComponent(() => import('@/views/dictionary/criteria/CriteriaDetail.vue'));
const dictionaryRevenueAgency = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRevenueBudget/DictionaryRevenueAgency.vue'),
);
const dictionaryRevenueAgencyDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRevenueBudget/DictionaryRevenueAgencyDetail.vue'),
);

const dictionaryRevenueBudgetWardsDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRevenueBudget/DictionaryRevenueBudgetWardsDetail.vue'),
);

const dictionaryRevenueBudgetSTCDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRevenueBudget/DictionaryRevenueBudgetSTCDetail.vue'),
);
const dictionaryRevenueBudgetWardsRate = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRevenueBudget/DictionaryRevenueBudgetWardsRate.vue'),
);

const dictionaryRegularDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRegular/DictionaryRegularDetail.vue'),
);

const regularExplanationList = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRegular/RegularExplanationList.vue'),
);

const targetExpenseDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/projectExpense/TargetExpenseDetail.vue'),
);
const deleteResult = defineAsyncComponent(() => import('@/views/dictionary/baseDictionary/DeleteResult.vue'));

const projectDetail = defineAsyncComponent(() => import('@/views/dictionary/projectExpense/ProjectDetail.vue'));
const baseEstimateDetail = defineAsyncComponent(() => import('@/views/estimate/BaseEstimateDetail.vue'));
const beginYearEstimateDetail = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/BeginYearEstimateDetail.vue'),
);
const expenseEstimateOtherByLaw = defineAsyncComponent(() =>
  import('@/views/estimate/estimateExpenseOther/ExpenseEstimateOtherByLaw.vue'),
);

const estimateProjectDetail = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/estimateProject/EstimateProjectDetail.vue'),
);

const estimateRegularDetail = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/estimateRegular/EstimateRegularDetail.vue'),
);

const estimateInvest = defineAsyncComponent(() =>
  import('@/views/estimate/beginYearEstimate/estimateInvest/EstimateInvest.vue'),
);
const enactNotification = defineAsyncComponent(() => import('@/views/estimate/popups/EnactNotification.vue'));
const expenseOtherDicPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estimateExpenseOther/popup/ExpenseOtherDicPopup.vue'),
);

const calculationBasisDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/calculationBasis/CalculationBasisDetail.vue'),
);

const dictionaryPresentSettingAdvancedGroupData = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentSettingAdvancedGroupData.vue'),
);

const dictionarySettingDetailAfterMerge = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionarySettingDetailAfterMerge.vue'),
);

const baseEstimateRegularDetail = defineAsyncComponent(() => import('@/views/estimate/BaseEstimateRegularDetail.vue'));

const storageTemplateExplanationList = defineAsyncComponent(() =>
  import('@/views/dictionary/storageTemplate/StorageTemplateExplanationList.vue'),
);
const storageTemplateExplanations = defineAsyncComponent(() =>
  import('@/views/dictionary/storageTemplate/StorageTemplateExplanations.vue'),
);
const storageTemplateExplanationSyncPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/storageTemplate/popup/StorageTemplateExplanationSyncPopup.vue'),
);
const pushTemplateExplanationToSystem = defineAsyncComponent(() =>
  import('@/views/dictionary/storageTemplate/PushTemplateExplanationToSystem.vue'),
);

const dictionaryPatternRegularFieldSort = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPatternRegular/DictionaryPatternRegularFieldSort.vue'),
);

const dictionaryPresentPrintViewPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentPrintViewPopup.vue'),
);

const reportCustomPrintPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryReportCustom/ReportCustomPrintPopup.vue'),
);


const dictionaryPresentPrintListPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentPrintListPopup.vue'),
);

const dictionarySummaryPrintListPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryReportCustom/DictionarySummaryPrintListPopup.vue'),
);

const dictionaryPresentPrintViewExcelPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentPrintViewExcelPopup.vue'),
);

const reportTemplateFilePrintPopup = defineAsyncComponent(() =>
  import('@/views/reportFile/ReportTemplateFilePrintPopup.vue'),
);

const dictionaryPatternRegularEditInfoPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPatternRegular/DictionaryPatternRegularEditInfoPopup.vue'),
);

const dictionaryPresentQuickSearch = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DictionaryPresentQuickSearch.vue'),
);

const ceilingExpensePublishDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/ceilingExpensePublish/CeilingExpensePublishDetail.vue'),
);

const chooseFieldsPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/ceilingExpensePublish/ChooseFieldsPopup.vue'),
);

const chooseChildOrganizationPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/ceilingExpensePublish/ChooseChildOrganizationPopup.vue'),
);
const createSubmitCeilingExpenseDetail = defineAsyncComponent(() =>
  import('@/views/dictionary/ceilingExpensePublish/CreateSubmitCeilingExpenseDetail.vue'),
);
const viewCeilingExpenseNotify = defineAsyncComponent(() =>
  import('@/views/dictionary/ceilingExpensePublish/ViewCeilingExpenseNotify.vue'),
);

const salarySettingPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionarySalary/popup/salarySetting/SalarySettingPopup.vue'), 
);

const requestSubmitEstimateArrgrate = defineAsyncComponent(() =>
  import('@/views/estimateArrgrateThreeYear/popup/RequestSubmitEstimateArrgrate.vue'),
);

const formRequiredPasswordUploadExplanationToSystem = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/FormRequiredPasswordUploadExplanationToSystem.vue'),
);

const dictionaryRegularFromSection = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRegular/DictionaryRegularFromSection.vue'),
);

const dictionaryRegularFromSectionValidatePopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRegular/DictionaryRegularFromSectionValidatePopup.vue'),
);

const dictionaryRegularFromSectionValidateDetailPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRegular/DictionaryRegularFromSectionValidateDetailPopup.vue'),
);

const insertManyExplanationToRegularPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRegular/InsertManyExplanationToRegularPopup.vue'),
);

const dictionaryRegularSelectedInsertExplanationPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryRegular/DictionaryRegularSelectedInsertExplanationPopup.vue'),
);


const fieldQuotaSetup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/FieldQuotaSetup.vue'),
);

const fieldQuotaSetupView = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/FieldQuotaSetupView.vue'),
);

const dictionaryPresentExtendDisplayConditionSettings = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/DataTable/DictionaryPresentExtendDisplayConditionSettings.vue'),
);

const reportCustomLinkPopup = defineAsyncComponent(() =>
  import('@/views/dictionary/dictionaryPresentOther/ReportCustomLinkPopup.vue'),
);

const reportTemplateFileEditPopup = defineAsyncComponent(() =>
  import('@/views/reportTemplateFile/ReportTemplateFileEditPopup.vue'),
);

const reportTemplateFileRelationPopup = defineAsyncComponent(() =>
  import('@/views/reportTemplateFile/popup/ReportTemplateFileRelationPopup.vue'),
);

const reportTemplateFileSelectionDuplicate = defineAsyncComponent(() =>
  import('@/views/reportTemplateFile/popup/ReportTemplateFIleSelectionDuplicate.vue'),
);

const reportTemplateFileFormularSetupPopup = defineAsyncComponent(() =>
  import('@/views/reportTemplateFile/popup/ReportTemplateFileFormularSetupPopup.vue'),
);

const reportTemplateFileEditNamePopup = defineAsyncComponent(() =>
  import('@/views/reportTemplateFile/popup/ReportTemplateFileEditNamePopup.vue'),
);

export function registerDictionary(app) {
  app.component('RevenueOtherDetail', revenueOtherDetail);
  app.component('DictionaryFeesDetail', dictionaryFeesDetail);
  app.component('DictionaryPresentSetup', dictionaryPresentSetup);
  app.component('DictionaryPresentDetail', dictionaryPresentDetail);
  app.component('DictionaryReportCustomDetail', dictionaryReportCustomDetail);
  app.component('DictionaryPresentEdit', dictionaryPresentEdit);
  app.component('DictionaryPresentWorkbook', dictionaryPresentWorkbook);
  app.component('DictionaryPresentView', dictionaryPresentView);
  app.component('DictionaryReportCustomTool', dictionaryReportCustomTool);
  app.component('DictionaryPresentCustom', dictionaryPresentCustom);
  app.component('DictionaryPresentCustomColumn', dictionaryPresentCustomColumn);
  app.component('DictionaryReportCustomPrint', dictionaryReportCustomPrint);
  app.component('DictionaryPresentCustomPrintGeneral', dictionaryPresentCustomPrintGeneral);
  app.component('DictionaryPresentCustomPrintSettingArea', dictionaryPresentCustomPrintSettingArea);
  app.component('DictionaryPresentCustomPrintSettingCell', dictionaryPresentCustomPrintSettingCell);
  app.component('DictionaryPresentCustomPrintSettingCellCondition', dictionaryPresentCustomPrintSettingCellCondition);
  app.component('DictionaryPresentDatatableDetail', dictionaryPresentDatatableDetail);
  app.component('OptionExplanationFormModelPopup', optionExplanationFormModelPopup);
  app.component('DictionaryPresentDatatableDetailValue', dictionaryPresentDatatableDetailValue);
  app.component('DictionaryPresentDatatableCalculator', dictionaryPresentDatatableCalculator);
  app.component('DictionaryPresentDatatableDetailListConditions', dictionaryPresentDatatableDetailListConditions);
  app.component('FieldQuickSearch', fieldQuickSearch);
  app.component('ReportQuickSearch', reportQuickSearch);
  app.component('ExpenseInvestDetail', expenseInvestDetail);
  app.component('ExpenseInvestTaskDetail', expenseInvestTaskDetail);
  app.component('DictionaryBusinessDetail', dictionaryBusinessDetail);
  app.component('DictionaryFeesSetRatio', dictionaryFeesSetRatio);
  app.component('CriteriaDetail', criteriaDetail);
  app.component('DictionaryRegularDetail', dictionaryRegularDetail);
  app.component('StorageTemplateExplanationList', storageTemplateExplanationList);
  app.component('StorageTemplateExplanations', storageTemplateExplanations);
  app.component('TargetExpenseDetail', targetExpenseDetail);
  app.component('ProjectDetail', projectDetail);
  app.component('DictionaryExpenseOtherDetail', dictionaryExpenseOtherDetail);
  app.component('DictionaryPatternRegularDetail', dictionaryPatternRegularDetail);
  app.component('DictionaryPatternRegularFieldList', dictionaryPatternRegularFieldList);
  app.component('DictionaryPatternRegularAddSubItemsPopup', dictionaryPatternRegularAddSubItemsPopup);
  app.component('DictionaryAddRegularFailPopup', dictionaryAddRegularFailPopup);
  app.component('DeleteResult', deleteResult);
  app.component('DictionaryRevenueBudgetDetail', dictionaryRevenueBudgetDetail);
  app.component('DictionaryRevenueBudgetRate', dictionaryRevenueBudgetRate);
  app.component('DictionaryRevenueAgency', dictionaryRevenueAgency);
  app.component('DictionaryRevenueAgencyDetail', dictionaryRevenueAgencyDetail);
  app.component('DictionaryRevenueBudgetWardsDetail', dictionaryRevenueBudgetWardsDetail);
  app.component('DictionaryRevenueBudgetSTCDetail', dictionaryRevenueBudgetSTCDetail);
  app.component('DictionaryRevenueBudgetWardsRate', dictionaryRevenueBudgetWardsRate);
  app.component('BaseEstimateDetail', baseEstimateDetail);
  app.component('BeginYearEstimateDetail', beginYearEstimateDetail);
  app.component('ExpenseEstimateOtherByLaw', expenseEstimateOtherByLaw);
  app.component('EstimateProjectDetail', estimateProjectDetail);
  app.component('EstimateRegularDetail', estimateRegularDetail);
  app.component('EstimateInvest', estimateInvest);
  app.component('EnactNotification', enactNotification);
  app.component('ExpenseOtherDicPopup', expenseOtherDicPopup);
  app.component('CalculationBasisDetail', calculationBasisDetail);
  app.component('BaseEstimateRegularDetail', baseEstimateRegularDetail);
  app.component('RegularExplanationList', regularExplanationList);
  app.component('DictionaryPresentSettingAdvancedGroupData', dictionaryPresentSettingAdvancedGroupData);
  app.component('StorageTemplateExplanationSyncPopup', storageTemplateExplanationSyncPopup);
  app.component('DictionaryPatternRegularFieldSort', dictionaryPatternRegularFieldSort);
  app.component('DictionarySettingDetailAfterMerge', dictionarySettingDetailAfterMerge);
  app.component('DictionaryPresentPrintViewPopup', dictionaryPresentPrintViewPopup);
  app.component('ReportCustomPrintPopup', reportCustomPrintPopup);
  app.component('DictionarySummaryPrintListPopup', dictionarySummaryPrintListPopup);
  app.component('DictionaryPresentPrintListPopup', dictionaryPresentPrintListPopup);
  app.component('DictionaryPresentPrintViewExcelPopup', dictionaryPresentPrintViewExcelPopup);
  app.component('ReportTemplateFilePrintPopup', reportTemplateFilePrintPopup);
  app.component('DictionaryPatternRegularEditInfoPopup', dictionaryPatternRegularEditInfoPopup);
  app.component('DictionaryPresentQuickSearch', dictionaryPresentQuickSearch);
  app.component('CeilingExpensePublishDetail', ceilingExpensePublishDetail);
  app.component('ChooseFieldsPopup', chooseFieldsPopup);
  app.component('ChooseChildOrganizationPopup', chooseChildOrganizationPopup);
  app.component('CreateSubmitCeilingExpenseDetail', createSubmitCeilingExpenseDetail)
  app.component('ViewCeilingExpenseNotify', viewCeilingExpenseNotify);
  app.component('SalarySettingPopup', salarySettingPopup);
  app.component('RequestSubmitEstimateArrgrate', requestSubmitEstimateArrgrate);
  app.component('FormRequiredPasswordUploadExplanationToSystem', formRequiredPasswordUploadExplanationToSystem);
  app.component('PushTemplateExplanationToSystem', pushTemplateExplanationToSystem);
  app.component('DictionaryRegularFromSection', dictionaryRegularFromSection);
  app.component('DictionaryRegularFromSectionValidatePopup', dictionaryRegularFromSectionValidatePopup);
  app.component('DictionaryRegularFromSectionValidateDetailPopup', dictionaryRegularFromSectionValidateDetailPopup);
  app.component('InsertManyExplanationToRegularPopup', insertManyExplanationToRegularPopup);
  app.component('DictionaryRegularSelectedInsertExplanationPopup', dictionaryRegularSelectedInsertExplanationPopup);
  app.component('FieldQuotaSetup', fieldQuotaSetup);
  app.component('FieldQuotaSetupView', fieldQuotaSetupView);
  app.component('DictionaryPresentExtendDisplayConditionSettings', dictionaryPresentExtendDisplayConditionSettings);
  app.component('ReportCustomLinkPopup', reportCustomLinkPopup);
  app.component('ReportTemplateFileEditPopup', reportTemplateFileEditPopup);
  app.component('ReportTemplateFileRelationPopup', reportTemplateFileRelationPopup);
  app.component('ReportTemplateFileSelectionDuplicate', reportTemplateFileSelectionDuplicate);
  app.component('ReportTemplateFileFormularSetupPopup', reportTemplateFileFormularSetupPopup);
  app.component('ReportTemplateFileEditNamePopup', reportTemplateFileEditNamePopup);
}
